export default function Footer() {
  return (
    <footer className="bg-[#0071BC] text-white text-center text-sm py-6 px-4">
      <div className="mb-2">
        Kuala Lumpur Tower, No. 2 Jalan Puncak Off Jalan P. Ramlee 50250 Kuala Lumpur Malaysia
      </div>
      <div className="mb-2">Tel: +603 2630 3099</div>
      <div className="mb-4">
        LSH Service Master Sdn Bhd Company No. 202401025891 (1571740-A)
      </div>
      <div className="border-t border-white/20 my-4 mx-auto w-4/5"></div>
      <div className="space-x-2 mb-4">
        <a href="#" className="hover:underline">Privacy Policy</a>
        <span>|</span>
        <a href="#" className="hover:underline">Terms and Conditions</a>
        <span>|</span>
        <a href="#" className="hover:underline">About Us</a>
      </div>
      <div className="border-t border-white/20 my-4 mx-auto w-4/5"></div>
      <div>©2025 Kuala Lumpur Tower. All Rights Reserved.</div>
    </footer>
  );
}
